import styled from "styled-components";
import { useElementSize } from "usehooks-ts";
import LoadingAnimation from "../loadingAnimation";

interface WidgetLoadingProps {
  compact?: boolean;
}

const WidgetLoading = ({ compact = false }: WidgetLoadingProps) => {
  const [containerRef] = useElementSize();

  return (
    <Wrapper ref={containerRef} $compact={compact}>
      <LoadingAnimation size={compact ? 48 : 80} />
      <span>Widget Loading...</span>
    </Wrapper>
  );
};

export default WidgetLoading;

const Wrapper = styled.div<{ $compact?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: ${({ $compact }) => ($compact ? '6px' : '8px')};

  span {
    font-size: ${({ $compact }) => ($compact ? '12px' : '14px')};
    color: #91a1ac;
    font-weight: 500;
  }
`;
